<div class="container mt-4">
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center">Assinar Documento</h1>
      <p class="text-center">Instruções:</p>
      <p class="text-center">1º - Você deve clicar no botão 'ASSINAR'.</p>
      <p class="text-center">2º - Vamos te enviar um TOKEN de confirmação para o e-mail: <strong>{{emailUrl}}</strong>.</p>
      <p class="text-center">3º - Use o TOKEN enviado por e-mail para adicionar ao pequeno formulário em tela.</p>

      

    </div>
  </div>
  <div class="row">
    <div class="col-md-12 text-center">
      
        <div #signatureDiv class="d4sign-container"></div>
    </div>
  </div>

</div>>

